module.exports = "../../static/images/aboutus.2aece9.png";